import {
  SESSION_TYPES
} from '../../config/constants'

import createSessionWithExpert from './create_session_with_expert'

export default (expert, user, sessionLength, startTime) => {
  if (!expert || !user || !sessionLength || !startTime) return
  if (!expert.get('uid') || !user.get('uid')) return

  return createSessionWithExpert(expert.get('uid'), user.get('uid'), sessionLength, startTime, SESSION_TYPES.BOOKED)
}



/** WEBPACK FOOTER **
 ** ./modules/shared/data/setters/create_future_session_with_expert.js
 **/